<div class="pattern-editor-container">
  <!-- Pattern Metadata Section -->
  <div class="form-row">
    <vdr-form-field [label]="'Template Label'" class="form-item">
      <input type="text" [formControl]="labelControl" class="form-control" />
    </vdr-form-field>
  </div>
  <div class="form-row">
    <vdr-form-field [label]="'Template Description'" class="form-item">
      <vdr-rich-text-editor [formControl]="descriptionControl" class="form-control">
      </vdr-rich-text-editor>
    </vdr-form-field>
  </div>
  <div class="form-row">
    <span class="form-label">Customer Photo Minimum Size Requirements</span>
  </div>
  <div class="form-row">
    <vdr-form-field class="form-item">
      <span>Width(px):</span><input type="number" [formControl]="minWidthControl" class="form-control ml-2" />
    </vdr-form-field>
    <vdr-form-field class="form-item">
      <span>Height(px):</span><input type="number" [formControl]="minHeightControl" class="form-control ml-2" />
    </vdr-form-field>
  </div>
  <div class="form-row">
    <vdr-form-field [label]="'Background Image Display Type'" class="form-item">
      <select class="form-control"
          [formControl]="backgroundImageDisplayTypeControl">
        <option value="name-list">Name List</option>
        <option value="image-tiles">Image Tiles</option>
      </select>
    </vdr-form-field>
  </div>
  <vdr-form-field [label]="'Background Images'" class="form-row">
    <vdr-dynamic-form-input #backgroundImagesInput
      [control]="backgroundImagesControl"
      [def]="{
        type: 'string',
        list: true,
        ui: {
          component: 'labeld-image-form',
        }
      }"
    >
    </vdr-dynamic-form-input>
  </vdr-form-field>

  <div class="controls-container">
    <div class="pattern-controls">
      <div class="controls-header">
        <div class="button-group">
          <button
            class="btn btn-primary mr-8"
            (click)="resetCanvasWithConfirm()"
          >
            Reset Canvas
          </button>
          <button
            class="btn btn-primary mr-8"
            (click)="addRect()"
          >
            Add One New Frame
          </button>
          <button *ngIf="patternGroups.length > 1"
            class="btn btn-danger mr-8"
            (click)="removeRect()"
          >
            Delete Last Frame
          </button>
        </div>
      </div>
      <div class="form-row">
        <vdr-form-field [label]="'Canvas Width (max 800)'" class="form-item">
          <input type="number" [formControl]="canvasWidthControl" class="form-control" />
        </vdr-form-field>
        <vdr-form-field [label]="'Height (max 800)'" class="form-item">
          <input type="number" [formControl]="canvasHeightControl" class="form-control" />
        </vdr-form-field>
      </div>
    </div>
  </div>

  <div class="canvas-container">
    <div class="ruler horizontal-ruler">
      <div *ngFor="let mark of rulerMarks" class="ruler-mark" [style.left.px]="mark">
        <div class="mark-line"></div>
        <div class="mark-value">{{mark}}</div>
      </div>
    </div>
    <div class="ruler vertical-ruler">
      <div *ngFor="let mark of rulerMarks" class="ruler-mark" [style.top.px]="mark">
        <div class="mark-line"></div>
        <div class="mark-value">{{mark}}</div>
      </div>
    </div>
    <div class="canvas-wrapper">
      <canvas id="patternCanvas"></canvas>
    </div>
  </div>

  <!-- Selected Frame Editing Controls -->
  <div class="frame-settings-container">
    <ng-container *ngIf="activeRectIndex >= 0">
      <div class="form-row">
        <button *ngIf="patternGroups.length > 1"
          class="btn btn-danger btn-sm"
          (click)="removeSelectedFrame()">
          Delete This Frame
        </button>
      </div>
      <div class="form-row">
        <vdr-form-field [label]="'Frame Name'" class="form-item">
          <input type="text" [formControl]="selectedFrameNameControl" class="form-control" maxlength="maxLabelTextLength/2" />
        </vdr-form-field>
        <vdr-form-field
          [label]="'Frame Label (' + (selectedFrameLabelControl.value?.length || 0) + ' of ' + maxLabelTextLength + ' chars)'"
          class="form-item">
          <input type="text" [formControl]="selectedFrameLabelControl" class="form-control" maxlength="maxLabelTextLength" />
        </vdr-form-field>
      </div>
      <div class="form-row">
        <vdr-form-field [label]="'Label Color'" class="form-item form-item-short">
          <input type="color" [formControl]="selectedFrameLabelColorControl" class="form-control label-color-input" />
        </vdr-form-field>
        <vdr-form-field [label]="'Label Font Size'" class="form-item form-item-short">
          <input type="number" [formControl]="selectedFrameLabelFontSizeControl" class="form-control" min="8" max="200" />
        </vdr-form-field>
      </div>
      <div class="form-row">
        <vdr-form-field [label]="'Position X'" class="form-item">
          <input type="number" [formControl]="selectedFrameXControl" class="form-control" />
        </vdr-form-field>
        <vdr-form-field [label]="'Position Y'" class="form-item">
          <input type="number" [formControl]="selectedFrameYControl" class="form-control" />
        </vdr-form-field>
        <vdr-form-field [label]="'Width'" class="form-item">
          <input type="number" [formControl]="selectedFrameWidthControl" class="form-control" />
        </vdr-form-field>
        <vdr-form-field [label]="'Height'" class="form-item">
          <input type="number" [formControl]="selectedFrameHeightControl" class="form-control" />
        </vdr-form-field>
      </div>

      <!-- Nested text-overlay groups scoped to the currently selected image-frame. -->
      <div class="frame-text-overlays-panel">
        <div class="form-row">
          <span class="form-label">Text Overlay Groups (for selected frame)</span>
        </div>
        <text-frames-form
          [groups]="selectedFrameTextGroups"
          [groupNameContext]="selectedFrameDefaultName"
          (groupsChanged)="onSelectedFrameTextGroupsChanged($event)"
        ></text-frames-form>
      </div>
    </ng-container>
    <p *ngIf="activeRectIndex < 0 && patternGroups.length > 0" class="hint-text">
      Click a frame on the canvas to edit its properties.
    </p>
  </div>


</div>